import { call, put, select, all, takeEvery } from 'redux-saga/effects';
import { getJSON, putJSON, deleteJSON } from '../../util';

export function* getLists() {
    const api = yield select(state => state.api.host);
    const user = yield select(state => state.user);
    const lists = yield call(getJSON, `${api}/mail/email_list`);
    const subscribed = yield call(getJSON, `${api}/mail/subscription/${user.member_uuid}`);
    const filtered_lists = lists.filter((list) => {
        if (list.preferences) {
            list.intent = false;
            list.subscribed = subscribed.some(slist => slist.email_list == list.code && slist.subscribed);
            list.unsubscribed = subscribed.some(slist => slist.email_list == list.code && !slist.subscribed);
            return list;
        }

        return null;
    });

    filtered_lists.map(list => ({ ...list, dirty: false }));

    yield put({
        type: 'mail-lists:update',
        payload: {
            lists: filtered_lists,
            dirty: false,
        },
    });
}

export function* saveLists({ payload }) {
    yield put({
        type: 'mail-lists:update',
        payload: {
            submitting: true,
            error: null,
        },
    });

    const lists = yield select(state => state['mail-lists'].lists);

    try {
        const location = payload && payload.location
            ? payload.location
            : document.location.href;

        yield all(lists.map(list => call(updateList, list, location)));
    } catch (e) {
        const error = typeof e == 'object' && Object.keys(e).length == 0 ? null : e;
        yield put({
            type: 'mail-list:update',
            payload: {
                submitting: false,
                error: error,
            },
        });

        return;
    }

    yield call(getLists);

    yield put({
        type: 'mail-lists:update',
        payload: {
            submitting: false,
        },
    });
}

function* updateList(list, location) {
    const api = yield select(state => state.api.host);
    const user = yield select(state => state.user);
    const url = `${api}/mail/subscription/${user.member_uuid}/${list.code}`;

    if (list.subscribed && list.intent) { //are subscribed, want to unsubscribe
        yield call(deleteJSON, url, { reason: 'prefs', location: location });
        list.subscribed = false;
    } else if (list.intent) { //not subscribed, want to subscribe
        yield call(putJSON, url, { reason: 'prefs', location: location });
        list.subscribed = true;
    }

    list.intent = false;

    return list;
}

export function* root() {
    yield all([
        takeEvery('mail-lists:get', getLists),
        takeEvery('mail-lists:save', saveLists),
    ]);
}
